import { Component, ViewChild } from '@angular/core';
import { ShowComponent } from '../../common/component/show.component';

import { BankAccountOwnersComponent } from '../bank-account-owners/bank-account-owners.component';

@Component({
	selector: 'app-bank-account',
	templateUrl: './bank-account.component.html',
	styleUrls: ['./bank-account.component.css'],
})
export class BankAccountComponent extends ShowComponent {
	protected itemsBeforeDataLoad = 5;
	protected parentComponent = 'bankAccounts';
	protected questionConfirmSubscription;
	data = {
		id: null,
		number: null,
	};
	ownersTypes: Array<any> = [];
	users: Array<any> = [];
	drivers: Array<any> = [];
	vehicles: Array<any> = [];
	departments: Array<any> = [];
	@ViewChild(BankAccountOwnersComponent) bankAccountOwners: BankAccountOwnersComponent;

	protected loadBefore() {
		this.api.get('/bankOwnersTypes', (result, error) => {
			this.ownersTypes = result.data;
			this.loadData();
		});
		this.api.get('/users', (result, error) => {
			this.users = result.data;
			this.loadData();
		});
		this.api.get('/drivers', (result, error) => {
			this.drivers = result.data;
			this.loadData();
		});
		this.api.get('/vehicles', (result, error) => {
			this.vehicles = result.data;
			this.loadData();
		});
		this.api.get('/departments', (result, error) => {
			this.departments = result.data;
			this.loadData();
		});
	}

	showAdd() {
		this.bankAccountOwners.showAdd();
	}
}
